import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { FastField, Form, Formik, FormikHelpers, FormikProps } from 'formik'
import { createSearchParams, useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import FormikInput from './FormikInput'

interface Search {
  search: string
}

interface PageHeaderProps {
  title: string
  filterBtnAction?: () => void
  urlParams: any
  searchPlaceholder: string
  btnAction?: () => void
  btnText?: string
  nbOfExtraFilter?: number
}

const schema = Yup.object().shape({
  search: Yup.string(),
})

const PageHeader: React.FC<PageHeaderProps> = ({
  urlParams,
  title,
  btnAction,
  btnText,
  filterBtnAction,
  searchPlaceholder,
  nbOfExtraFilter = 0,
}) => {
  const navigate = useNavigate()

  const initialValues: Search = {
    search: urlParams.search || '',
  }

  const handleOnSubmit = (values: Search, formikBag: FormikHelpers<Search>) => {
    if (urlParams.search !== values.search) {
      navigate({
        search: `?${createSearchParams({
          search: values.search,
        })}`,
      })
    }

    formikBag.resetForm()
  }

  return (
    <div className="mb-10 flex flex-wrap justify-between ">
      <div className="flex items-center">
        <h1 className="page-title">{title}</h1>
      </div>
      <div className="flex flex-row items-center space-x-3">
        {btnAction && btnText && (
          <button type="button" className="btn btn-primary" onClick={btnAction}>
            <FontAwesomeIcon className="leading-icon" icon={faPlus} />
            {btnText}
          </button>
        )}

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={schema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={handleOnSubmit}
        >
          {({ isSubmitting }: FormikProps<Search>) => (
            <Form className="space-y-6" noValidate>
              <fieldset disabled={isSubmitting}>
                <div className="space-y-3">
                  <FastField type="search" name="search" component={FormikInput} placeholder={searchPlaceholder} />
                </div>
              </fieldset>
            </Form>
          )}
        </Formik>

        {filterBtnAction && (
          <button
            onClick={filterBtnAction}
            className={clsx({
              'btn btn-white': true,
              'btn-filter after:content-[attr(data-filter)]': urlParams.counter + nbOfExtraFilter,
            })}
            data-filter={urlParams.counter + nbOfExtraFilter}
          >
            Filter
          </button>
        )}
      </div>
    </div>
  )
}

export default PageHeader
